import Banner from './Banner';
import { useBannerData } from './useBannerData';

export function isSupportedPageType(pathname: string): boolean {
    // for v1 of banners, only these pages are supported
    const supportedPages = ['/', '/about', '/donors/search.html', '/donors/map.html'];

    return supportedPages.some((url) => {
        const pattern = url.endsWith('.html')
            ? new RegExp(`^${url.replace(/\./g, '\\.')}.*`) // allows all characters after search and map paths
            : new RegExp(`^${url}\\/?$`); // only allows trailing "/" to avoid vanity urls or other pages that start with /about
        return pattern.test(pathname);
    });
}

interface Props {
    bannerType: string
}

export default function HeaderBanner({ bannerType }: Props) {
    const supported = isSupportedPageType(window.location.pathname);
    const bannerData = useBannerData(supported ? bannerType ?? '' : '');

    return bannerData
        ? <div className="header-banner"><Banner {...bannerData} /></div>
        : null;
}
